// Upload Image action constants
export const GET_NEW_IMAGE_REQUEST = 'GET_NEW_IMAGE_REQUEST'
export const SET_UPLOAD_IMAGE = 'SET_UPLOAD_IMAGE'
export const SAVE_UPLOAD_IMAGE = 'SAVE_UPLOAD_IMAGE'
export const GET_LOADING_IMAGE = 'GET_LOADING_IMAGE'
export const UPLOAD_IMAGE_REQUEST = 'UPLOAD_IMAGE_REQUEST'
export const SET_TEMP_IMG = 'SET_TEMP_IMG'
export const DELETE_IMAGE = 'DELETE_IMAGE'



// WEBPACK FOOTER //
// ./app/actions/uploadImage/constants.js